import Backbone from "backbone";
import {getCookie} from "../utils/csrf";

export default class FeaturedNewsView extends Backbone.View {
    events() {
        return {
            "click .close": "close"
        }
    }

    initialize(options) {
        var dismissedId = getCookie('dismissed_featured_news_id');
        var currentId =  this.$el.attr('data-id');

        if(dismissedId == currentId)
            this.$el.addClass('hidden');
    }

    close(event) {
        event.preventDefault();
        document.cookie = 'dismissed_featured_news_id=' + this.$el.attr('data-id');
        this.$el.addClass('hidden');
    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/featuredNews.js